import script from "./repair-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./repair-drawer.vue?vue&type=style&index=0&id=622110db&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622110db"]])

export default __exports__